import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

const FooterContainer = styled.footer`
  background-color: ${({ theme }) => theme.colors.dark};
  color: white;
  padding: 4rem 0 2rem;
`;

const FooterContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 1rem;
  display: grid;
  grid-template-columns: 2fr 1fr 1fr 1fr;
  gap: 2rem;
  
  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    grid-template-columns: 1fr 1fr;
  }
  
  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    grid-template-columns: 1fr;
  }
`;

const FooterLogo = styled(Link)`
  font-size: 1.5rem;
  font-weight: 700;
  color: white;
  margin-bottom: 1rem;
  display: block;
`;

const FooterDescription = styled.p`
  color: ${({ theme }) => theme.colors.grayLight};
  margin-bottom: 1.5rem;
  max-width: 25rem;
`;

const FooterColumn = styled.div`
  display: flex;
  flex-direction: column;
`;

const FooterHeading = styled.h3`
  font-size: 1.125rem;
  margin-bottom: 1.5rem;
  font-weight: 600;
`;

const FooterLink = styled(Link)`
  color: ${({ theme }) => theme.colors.grayLight};
  margin-bottom: 0.75rem;
  transition: color 0.2s ease;
  
  &:hover {
    color: white;
  }
`;

const FooterBottom = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 2rem 1rem 0;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  margin-top: 3rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  
  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    flex-direction: column;
    gap: 1rem;
    text-align: center;
  }
`;

const Copyright = styled.p`
  color: ${({ theme }) => theme.colors.grayLight};
  font-size: 0.875rem;
`;

const SocialLinks = styled.div`
  display: flex;
  gap: 1rem;
`;

const SocialLink = styled.a`
  color: ${({ theme }) => theme.colors.grayLight};
  transition: color 0.2s ease;
  
  &:hover {
    color: white;
  }
`;

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <FooterContainer>
      <FooterContent>
        <FooterColumn>
          <FooterLogo to="/">FylePrep</FooterLogo>
          <FooterDescription>
            Streamline tax preparation for your CPA practice with our secure document collection
            and organization platform. Save time and reduce errors with FylePrep.
          </FooterDescription>
        </FooterColumn>
        
        <FooterColumn>
          <FooterHeading>Quick Links</FooterHeading>
          <FooterLink to="/features">Features</FooterLink>
          <FooterLink to="/">Home</FooterLink>
        </FooterColumn>
        
        <FooterColumn>
          <FooterHeading>Legal</FooterHeading>
          <FooterLink to="/privacy">Privacy Policy</FooterLink>
          <FooterLink to="/terms">Terms of Service</FooterLink>
        </FooterColumn>
      </FooterContent>
      
      <FooterBottom>
        <Copyright>© {currentYear} FylePrep. All rights reserved.</Copyright>
        
        <SocialLinks>
          {/* <SocialLink href="https://twitter.com" target="_blank" rel="noopener noreferrer">
            Twitter
          </SocialLink>
          <SocialLink href="https://linkedin.com" target="_blank" rel="noopener noreferrer">
            LinkedIn
          </SocialLink> */}
        </SocialLinks>
      </FooterBottom>
    </FooterContainer>
  );
};

export default Footer;
